import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pushToDataLayer } from "./helper/gtm";

const GTMPageView = () => {
  const location = useLocation();

  useEffect(() => {
    pushToDataLayer({
      event: "page_view",
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location]);

  return null;
};

export default GTMPageView;
